import { type TablesUrlGetResponseBody, pick } from '@ipfabric/utils';
import { removeNullAttributes } from '@ipfabric/utils/object/removeNullAttributes';
import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';
import { applyExternalFilters } from 'components/ApiTable/model/commands/applyExternalFilters';
import { changeSort } from 'components/ApiTable/model/commands/changeSort';
import { selectFilterPreset } from 'components/ApiTable/model/commands/selectFilterPreset';
import { applyTableSettings } from 'components/Table/model/commands/applyTableSettings';
import { pipe } from 'fp-ts/lib/function';

export type ApplySharedViewCommand = {
  view: TablesUrlGetResponseBody;
};

export const applySharedView: ApiTableCommandFactory<ApplySharedViewCommand> =
  (cmdContext, dispatch) =>
  ({ view }) => {
    if (view.selectedFilterPreset) {
      dispatch(selectFilterPreset, { preset: view.selectedFilterPreset });
    }
    if (view.filters) {
      dispatch(applyExternalFilters, { filters: view.filters });
    }
    if (view.sort) {
      dispatch(changeSort, { sort: view.sort });
    }
    const settings = pipe(
      view,
      pick([
        'orderedColumns',
        'columnVisibility',
        'autoSizedColumns',
        'columnWidth',
      ]),
      // Response started to send `null` values instead of not being present
      // for some attributes with PSQL migration.
      // To make it compatible with the rest of implementation, we just remove null
      // attributes to make the result object compatible with TableSettings type.
      removeNullAttributes,
    );

    if (Object.keys(settings).length > 0) {
      cmdContext.getTableModel().dispatch(applyTableSettings, { settings });
    }
  };
